import useFormatMonth from "@src/modules/shared/hooks/useFormatMonth";

const useStudyDateFormat = () => {
  const formatMonth = useFormatMonth();
  return (date: Date) =>
    `${formatMonth(date)} ${date.getDate()}, ${date.getFullYear()}`;
};

export default useStudyDateFormat;
